import React from "react";
import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";

const DeleteListingAlertModal = ({ loading, onClose, onDelete, open }) => (
  <Modal
    id="delete-alert-listing-modal"
    show={open}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="Are you sure you want to delete this Listing Alert?" closeButton />

    <Modal.Body>
      Deleting a listing alert will also delete the corresponding saved search from this contact&apos;s IDX
      account. This action cannot be undone.
    </Modal.Body>

    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
      <Button size="medium" schema="tertiary" onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button size="medium" schema="warning" onClick={onDelete} isLoading={loading}>
        Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

DeleteListingAlertModal.propTypes = {
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

DeleteListingAlertModal.defaultProps = {
  loading: false,
};

export default DeleteListingAlertModal;
